module.exports = __webpack_public_path__ + "img/logo-dark.0cc490c0.svg";